import React, { useMemo } from 'react'
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as UserIcon } from '../images/user-icon.svg'
import { ReactComponent as MobileIcon } from '../images/mobile-icon.svg'
import { ReactComponent as ContactIcon } from '../images/contact-icon.svg'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import PageHeader from '../components/PageHeader';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUpdateReferencesMutation } from '../lib/services/employmentApi';
import { closeErrorModal, openErrorModal, setPageError } from '../lib/features/employmentSlice';
import CenteredPopup from '../components/popups/CenteredPopup';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";

function References() {
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const [updateReferences, { isLoading: isUpdating }] = useUpdateReferencesMutation()
    const [tapClick] = useTapClickMutation()
    const { pageerror, isErrorModalOpen } = useSelector((state) => state.employment);
    const modalButtons = [
        { label: 'Close', onClick: () => dispatch(closeErrorModal()) }
    ]
    const handleConfirm = async (values) => {
        try {
            const requestData = {
                customer_refrence1: values.customer_refrence1,
                refrence_mobile1: values.refrence_mobile1.split(' ').join(''),
                customer_refrence2: values.customer_refrence2,
                refrence_mobile2: values.refrence_mobile2.split(' ').join('')
            }
            let jwt_token
            if (jwt) {
                jwt_token = jwt
                localStorage.setItem('jwt', jwt)
            } else {
                jwt_token = localStorage.getItem('jwt')
            }
            const scrt = secret ? secret : localStorage.getItem('secret')
            const result = await updateReferences({ ...requestData, jwt_token, scrt })
            if (result.data && (result.data.status === 'error' || result.data.http_code === 201)) {
                if (result.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    
                } else {
                    dispatch(setPageError(result.data.message))
                    dispatch(openErrorModal())
                }
            } else if (result.error) {
                dispatch(setPageError('Please check your internet or try again later.'))
                dispatch(openErrorModal())
            } else if (result.data && (result.data.status === 'success' || result.data.redirect_url)) {
                //localStorage.setItem("lastVisitedPage", '/take-selfie')
                //navigate('/take-selfie');
                if (result.data.redirect_url) {
                    const event_name = 'Web_reference_detail_submited'
                    const event_property = { Source: window.localStorage.getItem('utm_source'), segment: result.data.customer_segmentation }
                    await pushCleverTapEvent({ event_name, event_property })
                    window.location.href = result.data.redirect_url
                }
            }
        } catch (error) {
            dispatch(setPageError('Something went wrong. Please try again later.'));
            dispatch(openErrorModal())
        }
    }
    const formik = useFormik({
        initialValues: {
            customer_refrence1: '',
            refrence_mobile1: '',
            refrence_mobile2: '',
            customer_refrence2: '',
        },
        validationSchema: Yup.object({
            customer_refrence1: Yup.string()
                .required('Reference name is required')
                .matches(/^[A-Za-z\s]+$/, 'Only alphabets are allowed'),
            refrence_mobile1: Yup.string()
                .required('Mobile number is required')
                .matches(/^\d{5} \d{5}$/, 'Only numbers are allowed')
                .max(11, 'Mobile number cannot exceed 10 digits'),
            customer_refrence2: Yup.string()
                .required('Reference name is required')
                .matches(/^[A-Za-z\s]+$/, 'Only alphabets are allowed'),
            refrence_mobile2: Yup.string()
                .required('Mobile number is required')
                .matches(/^\d{5} \d{5}$/, 'Only numbers are allowed')
                .max(11, 'Mobile number cannot exceed 10 digits'),
        }),
        onSubmit: async (values) => {
            await handleConfirm(values)
            //dispatch(openModal());
            //dispatch(setBankDetails({ ifscCode: values.ifscCode, accountNumber: values.accountNumber }));
        },
    })

    const pickContact = async (type) => {
        if ('contacts' in navigator && 'select' in navigator.contacts) {
            try {
                const props = ['name', 'tel'];
                const contacts = await navigator.contacts.select(props, { multiple: false });

                if (contacts.length > 0) {
                    const selectedContact = contacts[0];
                    const contactName = (selectedContact?.name?.[0] || '').replace(/[^A-Za-z\s]/g, "");
                    const contactTel = (selectedContact?.tel?.[0] || '')
                        .replace(/^(\+91|0)/, '')
                        .replace(/[^0-9]/g, "");

                    if (type === 'type1') {
                        formik.setFieldValue('customer_refrence1', contactName);
                        formik.setFieldValue('refrence_mobile1', contactTel);
                        formik.setFieldTouched('customer_refrence1', false);
                        formik.setFieldTouched('refrence_mobile1', false);
                    }
                    if (type === 'type2') {
                        formik.setFieldValue('customer_refrence2', contactName);
                        formik.setFieldValue('refrence_mobile2', contactTel);
                        formik.setFieldTouched('customer_refrence2', false);
                        formik.setFieldTouched('refrence_mobile2', false);
                    }
                } else {
                    // Clear errors if the user skips the contact picker
                    if (type === 'type1') {
                        formik.setErrors((prevErrors) => ({
                            ...prevErrors,
                            customer_refrence1: undefined,
                            refrence_mobile1: undefined,
                        }));
                    }
                    if (type === 'type2') {
                        formik.setErrors((prevErrors) => ({
                            ...prevErrors,
                            customer_refrence2: undefined,
                            refrence_mobile2: undefined,
                        }));
                    }
                    //dispatch(setPageError('No contacts were selected.'));
                    //dispatch(openErrorModal());
                }
            } catch (error) {
                console.error('Error picking contact:', error);
                dispatch(setPageError('Error picking contact. You can still type and save.'));
                dispatch(openErrorModal());
            }
        } else {
            dispatch(setPageError('Contacts Picker API not supported on this browser.'));
            dispatch(openErrorModal());
        }
    };


    return (
        <div className={`external-wrapper employment-details`}>
            <CenteredPopup
                isOpen={isErrorModalOpen}
                buttons={modalButtons}
                onClose={() => dispatch(closeErrorModal())} icon={<WarningIcon />}>
                <p>{pageerror}</p>
            </CenteredPopup>
            <div className='page-content'>
                <PageHeader />
                <div className='page-heading'>
                    <h2 className='page-title'>Help us with your references</h2>
                    <p>This helps us validate your profile and expedite the process</p>
                </div>
                <form onSubmit={formik.handleSubmit}>
                    <div className='reference-box'>
                        <p className='reference-heading'>Reference 1</p>
                        <div className="input-wrapper">
                            <UserIcon className='icon' />
                            <input
                                type="text"
                                autoComplete='off'
                                name="customer_refrence1"
                                placeholder=" "
                                value={formik.values.customer_refrence1}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const formattedValue = value.replace(/[^A-Za-z\s]/g, "");
                                    formik.setFieldValue("customer_refrence1", formattedValue);
                                }}
                                onBlur={formik.handleBlur}
                                className={`form-control has-icon`}
                            />
                            <label>Full name of reference</label>
                            <ContactIcon className="right-icon" onClick={() => pickContact('type1')} />
                            {formik.errors.customer_refrence1 && formik.touched.customer_refrence1 && (
                                <div className="error">{formik.errors.customer_refrence1}</div>
                            )}
                        </div>
                        <div className="input-wrapper">
                            <MobileIcon className='icon' />
                            <input
                                type="text"
                                autoComplete='off'
                                name="refrence_mobile1"
                                maxLength={11}
                                placeholder=" "
                                inputMode="numeric"
                                value={formik.values.refrence_mobile1}
                                onChange={(e) => {
                                    const sanitizedValue = e.target.value ? e.target.value.replace(/[^0-9]/g, "") : '';
                                    const formattedValue = e.target.value ? sanitizedValue
                                        .match(/.{1,5}/g)
                                        ?.join(" ")
                                        .slice(0, 11) : '';
                                    if (formattedValue.length <= 11) {
                                        formik.setFieldValue("refrence_mobile1", formattedValue);
                                    }
                                }}
                                onBlur={formik.handleBlur}
                                className={`form-control has-icon`}
                            />
                            <label>Mobile number</label>
                            {formik.errors.refrence_mobile1 && formik.touched.refrence_mobile1 && (
                                <div className="error">{formik.errors.refrence_mobile1}</div>
                            )}
                        </div>
                    </div>
                    <div className='reference-box'>
                        <p className='reference-heading'>Reference 2</p>
                        <div className="input-wrapper">
                            <UserIcon className='icon' />
                            <input
                                type="text"
                                autoComplete='off'
                                name="customer_refrence2"
                                placeholder=" "
                                value={formik.values.customer_refrence2}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const formattedValue = value.replace(/[^A-Za-z\s]/g, "");
                                    formik.setFieldValue("customer_refrence2", formattedValue);
                                }}
                                onBlur={formik.handleBlur}
                                className={`form-control has-icon`}
                            />
                            <label>Full name of reference</label>
                            <ContactIcon className="right-icon" onClick={() => pickContact('type2')} />
                            {formik.errors.customer_refrence2 && formik.touched.customer_refrence2 && (
                                <div className="error">{formik.errors.customer_refrence2}</div>
                            )}
                        </div>
                        <div className="input-wrapper">
                            <MobileIcon className='icon' />
                            <input
                                type="text"
                                autoComplete='off'
                                name="refrence_mobile2"
                                placeholder=" "
                                inputMode="numeric"
                                maxLength={11}
                                value={formik.values.refrence_mobile2}
                                onChange={(e) => {
                                    const sanitizedValue = e.target.value ? e.target.value.replace(/[^0-9]/g, "") : '';
                                    const formattedValue = e.target.value ? sanitizedValue
                                        .match(/.{1,5}/g)
                                        ?.join(" ")
                                        .slice(0, 11) : '';
                                    if (formattedValue.length <= 11) {
                                        formik.setFieldValue("refrence_mobile2", formattedValue);
                                    }
                                }}
                                onBlur={formik.handleBlur}
                                className={`form-control has-icon`}
                            />
                            <label>Mobile number</label>
                            {formik.errors.refrence_mobile2 && formik.touched.refrence_mobile2 && (
                                <div className="error">{formik.errors.refrence_mobile2}</div>
                            )}
                        </div>
                    </div>
                    <div className='bottom-footer ps-0 pe-0'>
                        <p className='powered-by'>Powered by <StarfinLogo /></p>
                        <button type="submit" className={`btn btn-primary ${isUpdating ? 'disabled' : ''}`}>Continue</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default References
